// fr strings for messages/nav.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const nav: Dict = {
  "nav.home": "Accueil",
  "nav.create": "Créer",
  "nav.voices": "Voix",
  "nav.train": "Entraîner une voix",
  "nav.library": "Bibliothèque",
  "nav.tab.profile": "Profil",
  "nav.404.seoTitle": "Page introuvable | Jammable",
  "nav.404.title": "Page introuvable !",
  "nav.404.body": "On dirait que ce contenu n'existe plus.",
  "nav.404.home": "Retour à l'accueil",
  "nav.404.browse": "Parcourir les voix",
  "nav.404.discordLabel": "Tu cherches quelque chose ?",
  "nav.404.discordBody": "Demande à la communauté sur Discord",
  "nav.pricing": "Tarifs",
  "nav.affiliate": "Programme d'affiliation",
  "nav.api": "API",
  "nav.login": "Se connecter",
  "nav.signup": "S'inscrire",
  "nav.signupFree": "Inscription gratuite",
  "nav.getPlan": "Choisir un abonnement",
  "nav.discordAria": "Rejoindre le Discord de Jammable",
  "nav.discordJoin": "Rejoins notre Discord",
  "nav.openMenu": "Ouvrir le menu",
  "nav.closeMenu": "Fermer le menu",

  "nav.greet.0.0": "Déjà debout ?",
  "nav.greet.0.1": "Bonjour",
  "nav.greet.0.2": "Salut",
  "nav.greet.0.3": "Hello",
  "nav.greet.0.4": "Quoi de neuf ?",
  "nav.greet.1.0": "Yo",
  "nav.greet.1.1": "Hey",
  "nav.greet.1.2": "Coucou",
  "nav.greet.1.3": "Ça roule ?",
  "nav.greet.1.4": "Bon après-midi",
  "nav.greet.2.0": "Bonsoir",
  "nav.greet.2.1": "Hey, toi",
  "nav.greet.2.2": "Quoi de beau ?",
  "nav.greet.2.3": "Salut",
  "nav.greet.2.4": "Coucou",
  "nav.greet.3.0": "Toujours debout ?",
  "nav.greet.3.1": "Oiseau de nuit, hein ?",
  "nav.greet.3.2": "Yo, le noctambule",
  "nav.greet.3.3": "Pas sommeil ?",
  "nav.greet.3.4": "Ambiance nocturne",

  "nav.profile.view": "Voir le profil",
  "nav.profile.credit": "crédit",
  "nav.profile.credits": "crédits",
  "nav.profile.voicePass": "pass voix",
  "nav.profile.voices": "voix",
  "nav.profile.shop": "Boutique",
  "nav.profile.feedback": "Donner ton avis",
  "nav.profile.settings": "Paramètres",
  "nav.profile.apiDashboard": "Tableau de bord API",
  "nav.profile.signOut": "Se déconnecter",
  "nav.profile.signedOut": "Déconnecté !",
  "nav.profile.avatarAlt": "photo de profil",

  "nav.footer.tagline":
    "Des covers IA avec plus de 100 000 voix. Crée la tienne en quelques secondes.",
  "nav.footer.colCreate": "Créer",
  "nav.footer.colAccount": "Compte",
  "nav.footer.colLegal": "Mentions légales",
  "nav.footer.aiCover": "Générateur de covers IA",
  "nav.footer.voiceChanger": "Modificateur de voix IA",
  "nav.footer.voiceLibrary": "Bibliothèque de voix IA",
  "nav.footer.train": "Entraîner une voix",
  "nav.footer.weights": "Alternative à Weights.gg",
  "nav.footer.settings": "Paramètres",
  "nav.footer.earn": "Gagne de l'argent avec Jammable",
  "nav.footer.mcp": "Serveur MCP pour agents IA",
  "nav.footer.forgot": "Mot de passe oublié",
  "nav.footer.terms": "Conditions d'utilisation",
  "nav.footer.privacy": "Politique de confidentialité",
  "nav.footer.dmca": "Politique DMCA",
  "nav.footer.refunds": "Politique de remboursement",
  "nav.footer.pitchmeldBefore": "Utilise la",
  "nav.footer.pitchmeldLink": "technologie Pitchmeld",
  "nav.footer.pitchmeldAfter": "pour le traitement de la voix",

  "nav.language": "Langue",
};

export default nav;
